
/**
 * Module dependencies.
 */

import { Link, typography } from '../design-system';
import { ReactNode, useMemo } from 'react';
import qs from 'qs';
import styled from 'styled-components';

/**
 * Google authentication url.
 */

const googleAuthenticationUrl = `https://accounts.google.com/o/oauth2/v2/auth`;

/**
 * `Props` type.
 */

 type Props = {
  children: ReactNode;
  className?: string;
  credentials: {
    backRoute: string;
    clientId: string;
    redirectUrl: string;
    slug?: string;
    state?: any;
    type: 'redirect';
  };
  disabled?: boolean;
  onClick?: () => void;
};

/**
 * `StyledLink` styled component.
 */

const StyledLink = styled(Link)`
  ${typography.styles.textSmall}
`;

/**
 * Export `GoogleLink` component.
 */

export function GoogleLink(props: Props): JSX.Element {
  const { children, className, credentials, disabled, onClick } = props;
  const googleUrl = useMemo(() => {
    const params = {
      client_id: credentials.clientId,
      nonce: credentials.clientId,
      redirect_uri: credentials.redirectUrl,
      response_type: 'id_token token',
      scope: 'https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/contacts.other.readonly',
      state: qs.stringify({
        backRoute: credentials.backRoute,
        identityProvider: 'google',
        scope: 'contacts',
        slug: credentials.slug,
        type: credentials.type,
        ...credentials.state ?? {}
      })
    };

    const url = new URL(googleAuthenticationUrl);

    url.search = qs.stringify(params);

    return url.href;
  }, [credentials]);

  return (
    <StyledLink
      {...!disabled ? {
        href: googleUrl,
        onClick
      } : {}}
      className={className}
      disabled={disabled}
    >
      {children}
    </StyledLink>
  );
}
